import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { routing } from './app.routes';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CommonModule, DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule  } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatFormFieldModule } from '@angular/material/form-field';
import { JwtInterceptor } from '_interceptors/jwt.interceptor';
import { ErrorInterceptor } from '_interceptors/error.interceptor';
import { RootComponent } from './component/root/root.component';
import { RegisterComponent } from './component/page/register/register.component';
import { SidebarComponent } from './component/root/sidebar/sidebar.component';
import { HomeComponent } from './component/root/home/home.component';
import { ProfileComponent } from './component/profile/profile.component';
import { NavbarComponent } from './component/root/shared/navbar/navbar.component';
import { FigurecardComponent } from './component/root/shared/figurecard/figurecard.component';
import { ImagecardComponent } from './component/root/shared/imagecard/imagecard.component';
import { EditSubCategoryComponent } from './component/master/sub-category/edit-sub-category/edit-sub-category.component';
import { EditWarehouseComponent } from './component/master/warehouse/edit-warehouse/edit-warehouse.component';
import { MsgIconBtnComponent } from './component/root/shared/msgiconbtn/msgiconbtn.component';
import { LoginComponent } from './component/page/login/login.component';
import { LockComponent } from './component/page/lock/lock.component';
import { HeaderComponent } from './component/root/shared/header/header.component';
import { FooterComponent } from './component/root/shared/footer/footer.component';
import { SettingsComponent } from './component/settings/settings.component';
import { WizardComponent } from './component/root/wizard/wizard.component';
import { StateMasterComponent } from './component/master/state-master/state-master.component';
import { CityMasterComponent } from './component/master/city-master/city-master.component';
import { ProductMasterComponent } from './component/master/product-master/product-master.component';
import { CategoryMasterComponent } from './component/master/category-master/category-master.component';
import { SubCategoryComponent } from './component/master/sub-category/sub-category.component';
import { BrandComponent } from './component/master/brand/brand.component';
import { VenderComponent } from './component/master/vender/vender.component';
import { WarehouseComponent } from './component/master/warehouse/warehouse.component';
import { UserManagementComponent } from './component/user-management/user-management.component';
import { AddUserComponent } from './component/user-management/add-user/add-user.component';
import { EditUserComponent } from './component/user-management/edit-user/edit-user.component';
import { AddProductsComponent } from './component/master/product-master/add-products/add-products.component';
import { AddCategoryComponent } from './component/master/category-master/add-category/add-category.component';
import { AddSubCategoryComponent } from './component/master/sub-category/add-sub-category/add-sub-category.component';
import { AddBrandComponent } from './component/master/brand/add-brand/add-brand.component';
import { AddVenderComponent } from './component/master/vender/add-vender/add-vender.component';
import { AddWarehouseComponent } from './component/master/warehouse/add-warehouse/add-warehouse.component';
import { EditvendorComponent } from './component/master/vender/editvendor/editvendor.component';
import { EditBrandComponent } from './component/master/brand/edit-brand/edit-brand.component';
import { EditProductComponent } from './component/master/product-master/edit-product/edit-product.component';
import { EditCategoryComponent } from './component/master/category-master/edit-category/edit-category.component';
import { SettingsService } from './_services/settings.service';
import { FilterPipe } from './_pipes/filter.pipe';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ForgotpasswordComponent } from './component/page/login/forgotpassword/forgotpassword.component';
import { UpdatePasswordComponent } from './component/Accounts/UpdatePassword/update-password/update-password.component';
import { UserProfileComponent } from './component/Accounts/user-profile/user-profile.component';
import { BulkUserRegisterComponent } from './component/Accounts/bulk-user-register.component';
import { InvProjectsComponent } from './component/master/inv-projects/inv-projects.component';
import { AddInvProjectComponent } from './component/master/inv-projects/add-inv-project/add-inv-project.component';
import { EditInvProjectComponent } from './component/master/inv-projects/edit-inv-project/edit-inv-project.component';
import { IdleTimeoutDialogComponent } from './component/idle-timeout-dialog/idle-timeout-dialog.component';
import { EncryptionService } from './_services/encryption.service';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from 'environments/environment';
import { SpreadsheetValidateService } from './_services/spreadsheetValidation.service';
import { BulkCreateSubCategoryComponent } from './component/master/sub-category/bulk-create-sub-category.component';
import { AddCityComponent } from './component/master/city-master/add-city.component';
import { EditCityComponent } from './component/master/city-master/edit-city.component';
import { BulkCityCreateComponent } from './component/master/city-master/bulk-city-create.component';
import { PageNotFoundComponent } from './component/page/page-not-found/page-not-found.component';
import { ListAssetUsersComponent } from './component/master/AssetUser/list-asset-users.component';
import { AddAssetUserComponent } from './component/master/AssetUser/add-asset-user.component';
import { UpdateAssetUserComponent } from './component/master/AssetUser/update-asset-user.component';
import { PasswordStrengthComponentComponent } from './component/Accounts/UpdatePassword/password-strength-component/password-strength-component.component';
import { BulkAssetuserComponent } from './component/master/AssetUser/bulk-assetuser.component';
import { AddPurchaseOrderComponent } from './component/master/pomaster/add-purchase-order/add-purchase-order.component';
import { InputValidatorDirective } from './shared/directives/input-validator.directive';
import { ListPurchaseOrderComponent } from './component/master/pomaster/list-purchase-order/list-purchase-order.component';
import { ListPurchaseOrderDetailsComponent } from './component/master/pomaster/podetails/list-purchase-order-details/list-purchase-order-details.component';
import { FilterInputComponent } from './shared/component/filter-input.component';
import { SearchInputComponent } from './shared/component/search-input.component';
import { ColumnSelectorComponent } from './shared/component/column-selector.component';
import { EditPurchaseOrderDetailsComponent } from './component/master/pomaster/podetails/edit-purchase-order-details/edit-purchase-order-details.component';
import { EditPurchaseOrderComponent } from './component/master/pomaster/edit-purchase-order/edit-purchase-order.component';
import { BulkUploadPurchaseOrderComponent } from './component/master/pomaster/bulk-upload-purchase-order/bulk-upload-purchase-order.component';
import { BulkUploadPurchaseOrderDetailsComponent } from './component/master/pomaster/podetails/bulk-upload-purchase-order-details/bulk-upload-purchase-order-details.component';
import { AddChildPurchaseOrderComponent } from './component/master/pomaster/add-child-purchase-order/add-child-purchase-order.component';
import { AddMoreOrderDetailsComponent } from './component/master/pomaster/podetails/add-more-order-details/add-more-order-details.component';


const material = [
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatStepperModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,
  OverlayModule,
  MatFormFieldModule,
  MatSortModule,
 
];

@NgModule({
    declarations: [
        AppComponent,
        SidebarComponent,
        HomeComponent,
        ProfileComponent,
        NavbarComponent,
        FigurecardComponent,
        ImagecardComponent,
        MsgIconBtnComponent,
        LoginComponent,
        RootComponent,
        RegisterComponent,
        LockComponent,
        HeaderComponent,
        FooterComponent,
        SettingsComponent,
        WizardComponent,
        StateMasterComponent,
        CityMasterComponent,
        ProductMasterComponent,
        CategoryMasterComponent,
        SubCategoryComponent,
        BrandComponent,
        VenderComponent,
        WarehouseComponent,
        UserManagementComponent,
        AddUserComponent,
        EditUserComponent,
        AddProductsComponent,
        AddCategoryComponent,
        AddSubCategoryComponent,
         AddBrandComponent,
        AddVenderComponent,
        AddWarehouseComponent,
        EditvendorComponent,
        EditBrandComponent,
        EditProductComponent,
        EditCategoryComponent,
        EditWarehouseComponent,
        EditSubCategoryComponent,
        FilterPipe,
        ForgotpasswordComponent,
        UpdatePasswordComponent,
        PasswordStrengthComponentComponent,
        UserProfileComponent,
        BulkUserRegisterComponent,
        InvProjectsComponent,
        AddInvProjectComponent,
        EditInvProjectComponent,
        IdleTimeoutDialogComponent,
        BulkCreateSubCategoryComponent,
        AddCityComponent,
        EditCityComponent,
        BulkCityCreateComponent,
        PageNotFoundComponent,
        ListAssetUsersComponent,
        AddAssetUserComponent,
        UpdateAssetUserComponent,
        BulkAssetuserComponent,
        AddPurchaseOrderComponent,
        InputValidatorDirective,
        ListPurchaseOrderComponent,
        ListPurchaseOrderDetailsComponent,
        FilterInputComponent,
        SearchInputComponent,
        ColumnSelectorComponent,
        EditPurchaseOrderDetailsComponent,
        EditPurchaseOrderComponent,
        BulkUploadPurchaseOrderComponent,
        BulkUploadPurchaseOrderDetailsComponent,
        AddChildPurchaseOrderComponent,
        AddMoreOrderDetailsComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        routing,
        BrowserAnimationsModule,
        HttpClientModule,
        material,
         NgApexchartsModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true
        }),
       RecaptchaV3Module
    ],
    exports: [],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
       {provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey},
        SettingsService,
        DatePipe,
        EncryptionService,
        SpreadsheetValidateService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
